<div class="bottom_nav">
    <div class="container">
        <div class="stickyButton" style="padding-top: 5px;padding-bottom: 5px;">
            <div *ngIf="UserCondition" class="footernav py-2 ">
                <ul class="nav nav-pills" style=" padding-left: 0px;padding-right: 0px;width: 100%;">
                    <li class="nav-item col-xs-6">
                        <a [routerLink]="['../', 'resto']" routerLinkActive="active" class="nav-link">
                            <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="28"></tc-icon>
                            <span class="nav__text">Restaurant</span>
                        </a>
                    </li>
                    <li class="nav-item col-xs-6 ">
                        <a [routerLink]="['../',  'userprofile']" routerLinkActive="active" class="nav-link">
                            <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="26"></tc-icon>
                            <span class="nav__text">Profile</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>